<template>
    <div>
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 流向详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
  
      <div class="container">
         <div class="title">基本信息</div>
         <div class="flex">
             <div class="detail_item"><span class="name">订单号：</span><span class="desc">{{formData.orderCode}}</span></div>
             <div class="detail_item"><span class="name">发货单号：</span><span class="desc">{{formData.logisticsNo}}</span></div>
             <div class="detail_item"><span class="name">发货单：</span><span class="desc">{{formData.orderShipmentName}}</span></div>
             <div class="detail_item"><span class="name">创建时间：</span><span class="desc">{{formData.createTime}}</span></div>
           
         </div>
      </div>
      <div class="container">
         <div class="title">运单信息</div>
         <div class="flex">
             <div class="detail_item"><span class="name">配送方式：</span><span class="desc">{{formData.deliveryWayName}}</span></div>
             <div class="detail_item"><span class="name">运输类型：</span><span class="desc">{{formData.transportTypeName}}</span></div>
             <div class="detail_item"><span class="name">物流商：</span><span class="desc">{{formData.expressCompanyName}}</span></div>
             <div class="detail_item"><span class="name">运单号：</span><span class="desc">{{formData.billNo}}</span></div>
             <div class="detail_item"><span class="name">状态：</span><span class="desc">{{formData.statusName}}</span></div>
         </div>
      </div>
      <div class="container">
         <div class="title">运单跟踪</div>
         <el-table  :data="formData.eventList" style="width: 100%">
              <el-table-column  prop="eventTime"  label="时间"></el-table-column>
              <el-table-column  prop="eventDesc"  label="节点内容"></el-table-column>
        </el-table>
      </div>
      <div class="container">
         <div class="title">发货信息</div>
         <div class="flex">
             <div class="detail_item"><span class="name">供应商：</span><span class="desc">{{formData.supplierName}}</span></div>
             <div class="detail_item"><span class="name">发货人：</span><span class="desc">{{formData.senderRecipient}}</span></div>
             <div class="detail_item"><span class="name">发货人手机：</span><span class="desc">{{formData.deliPhone}}</span></div>
             <div class="detail_item"><span class="name">发货地址：</span><span class="desc">{{formData.deliAddress}}</span></div>
           
         </div>
      </div>
      <div class="container">
         <div class="title">收货信息</div>
         <div class="flex">
             <div class="detail_item"><span class="name">采购商：</span><span class="desc">{{formData.purchaseName}}</span></div>
             <div class="detail_item"><span class="name">收货人：</span><span class="desc">{{formData.receiveName}}</span></div>
             <div class="detail_item"><span class="name">收货人手机：</span><span class="desc">{{formData.mobiletelephone}}</span></div>
             <div class="detail_item"><span class="name">收货地址：</span><span class="desc">{{formData.receiveAddress}}</span></div>
           
         </div>
      </div>
    
 
    </div>
</template>
  
  <script>
  import Api from "../../api/logistics/index";
  import cApi from "../../api/company/index";
  
  // import utils from "../../utils/utils";
  export default {
    name: "userManage",
    props: {},
    data() {
      return {
        logisticsId:'',
        formData:{
            orderCode:'',
            logisticsNo:'',
            orderShipmentName:'',
            createTime:'',

            deliveryWayName:'',
            transportTypeName:'',
            expressCompanyName:'',
            billNo:'',
            statusName:'',

            eventList:[],
            supplierName:'',
            senderRecipient:'',
            deliPhone:'',
            deliAddress:'',

         
            purchaseName:'',
            receiveName:'',
            receiveAddress:'',
            mobiletelephone:''
          
        },
   
        loading: false,
      
  
      
       
      };
    },
    computed: {},
    watch:{
      $route:{
        handler(){
           this.logisticsId = this.$route.query.id;
           if(this.logisticsId){
             this.getCompanyLogisticsDetail();
           }
           
        }
      },
      // deep:true
    },
    created() {
      // this.logisticsId = this.$route.query.id;
      // this.getCompanyLogisticsDetail();
    },
    methods: {
      formatStatus(){
          return '已确认'
      },
    
      handleSelectionChange(val) {
        this.selectionData = val;
      },
    
      handleSizeChange(val) {
        this.queryData.pageSize = val;
        this.queryData.pageNum = 1
        this.getCompanyLogisticsList();
      },
      handleCurrentChange(val) {
        this.queryData.pageNum = val;
        this.getCompanyLogisticsList();
      },
 
     
      handleCheck(val) {
        this.checkUserShow = true;
        this.userData = val;
      },
      handleEdit(val) {
        this.addUserDialogShow = true;
        this.dialogTitle = "修改员工";
        this.userData = val;
      },
 
      getCompanyLogisticsDetail() {
        let params = {
          logisticsId:this.logisticsId
        };
        
        Api.getCompanyLogisticsDetail(params).then((res) => {
          Object.assign(this.formData,res.data)
          this.getShipment(res.data)
        });
      },
      getShipment(data) {
        let params = {
          orderId:data.orderNo,
          purchaseCompanyId:data.purchaseId,
        };
        
        cApi.getShipment(params).then((res) => {
          Object.assign(this.formData,res.data)
        });
      },
  
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container-external {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
  }
  .container {
    width: 100%;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      font-style: normal;
      margin-bottom: 10px;
    }
    .detail_item{
      flex:0 0 20%;
      display: flex;
      color: #333;
      // align-items: center;
      span{
        display: inline-block;
        line-height: 24px;
      }
      .name{
        flex: 0 0 100px;
        width: 100px;
        text-align: right;
      }
    }
  }
  </style>
  